import { render, staticRenderFns } from "./SectionOtherFeatures.vue?vue&type=template&id=2d53797f&scoped=true"
import script from "./SectionOtherFeatures.vue?vue&type=script&lang=ts"
export * from "./SectionOtherFeatures.vue?vue&type=script&lang=ts"
import style0 from "./SectionOtherFeatures.vue?vue&type=style&index=0&id=2d53797f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d53797f",
  null
  
)

export default component.exports